import { API_URLS } from "../config/api";

/**
 * Fetch soil data from OpenEPI API
 */
export async function fetchSoilData(lat, lon) {
  const essentialProperties = [
    "bdod",
    "clay",
    "sand",
    "silt",
    "soc",
    "phh2o",
    "nitrogen",
  ];
  const depths = ["0-5cm", "5-15cm", "15-30cm", "30-60cm"];
  const values = ["mean", "Q0.05", "Q0.95"];

  try {
    const params = new URLSearchParams();
    params.append("lat", lat);
    params.append("lon", lon);
    depths.forEach((d) => params.append("depths", d));
    essentialProperties.forEach((p) => params.append("properties", p));
    values.forEach((v) => params.append("values", v));

    const response = await fetch(
      `${API_URLS.OPENEPI_SOIL}?${params.toString()}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) throw new Error(`Soil API Error: ${response.statusText}`);
    return await response.json();
  } catch (error) {
    console.error("Error fetching soil data:", error);
    return { error: error.message };
  }
}
